const state = {
  canAddInterests: true,
  isEditingInterest: false,
  isEditingProfile: false,
  newInterests: [],
};

const mutations = {
  setCanAddInterests(state, isAdding) {
    state.canAddInterests = isAdding;
  },
  setIsEditingInterest(state, isEditing) {
    state.isEditingInterest = isEditing;
  },
  setIsEditingProfile(state, isEditing) {
    state.isEditingProfile = isEditing;
  },
  setInterests(state, interests) {
    state.newInterests = interests;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
